export const DL_LEGAL_REGULATION_ROUTE = 'regulacje-prawne';
